import {User, AnonymousUser, UserMinimal} from '@types';
import {UserIdentity} from './common/UserIdentity';
import RankText from './common/RankText';
import {useTranslation} from 'react-i18next';

export const UserItem = ({
    user,
    anonymous = false,
    href,
    target,
    showAvatar = true,
    showLevel = true,
    showVisibleRank = false,
    className = '',
    avatarClassName = '',
    avatarStyle = {},
    textClassName = '',
}: {
    user?: User | AnonymousUser | UserMinimal | null;
    anonymous?: boolean;
    href?: string;
    target?: string;
    showAvatar?: boolean;
    showLevel?: boolean;
    showVisibleRank?: boolean;
    className?: string;
    avatarClassName?: string;
    avatarStyle?: React.CSSProperties;
    textClassName?: string;
}) => {
    const {t} = useTranslation();

    if (!user && !anonymous) {
        return null;
    }

    const displayedRank = showVisibleRank
        ? user?.rank
        : user &&
            'displayRank' in user &&
            user.displayRank !== undefined &&
            user.displayRank !== null
          ? user.displayRank
          : user?.rank;

    return (
        <UserIdentity
            user={user}
            anonymous={anonymous}
            anonymousLabel={t('common.anonymous_player')}
            to={href}
            target={target}
            showAvatar={showAvatar}
            avatarSize={26}
            avatarClassName={avatarClassName}
            avatarStyle={avatarStyle}
            textClassName={`font-semibold ${textClassName}`}
            className={className}
            layout="inline"
            secondary={
                showLevel && displayedRank ? (
                    <span className="uppercase">
                        (
                        <RankText
                            rank={displayedRank}
                            showMark={false}
                            shortUnit
                        />
                        )
                    </span>
                ) : null
            }
        />
    );
};
